var map = {
	"./livingroom.png": "./src/images/SaiWan/livingroom.png",
	"./storage.png": "./src/images/SaiWan/storage.png",
	"./studyroom.png": "./src/images/SaiWan/studyroom.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images/SaiWan sync recursive \\.(png%7Cjpe?g%7Csvg)$";